import { render, staticRenderFns } from "./StampReport.vue?vue&type=template&id=d52e7980&scoped=true"
import script from "./StampReport.vue?vue&type=script&lang=js"
export * from "./StampReport.vue?vue&type=script&lang=js"
import style0 from "./StampReport.vue?vue&type=style&index=0&id=d52e7980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52e7980",
  null
  
)

export default component.exports